import styled from 'styled-components';

import { smallMediaQuery } from '../../common/utilities/sizeHelpers';

// TECHDEBT: hack to get rid of the top and bottom background image that is baked into the default page template
export const RemoveBackgroundAddMenu = styled.div`
    border-top: 1px solid #d2d6d9;
    margin-top: -39px;
    height: 100%;
    margin-bottom: -40px;
    background: linear-gradient(113.34deg, #208F99 0%, #2CAF49 116.34%);  
`;

export const Main = styled.div`
    width: 70%;
    margin: 0 auto;
    font-family: Source Sans Pro;
    font-style: normal;
    font-weight: 600;
    font-size: 32px;
    padding-bottom: 20px;

    @media ${smallMediaQuery} {
        margin-left: 10px;
    }
`;

export const MainContainer = styled.div`
    display: flex;
    flex-direction: row;
    justify-content: flex-start;
    width: 80%
    margin: 0 auto;
    height: 900px;

    @media ${smallMediaQuery} {
        margin-left: 10px;
    }
`;

export const ContentRow = styled.div`
    flex: 1;
`;

export const ContentRowRight = styled.div`
    flex: 1;
    background-image: url('./images/backgrounds/wb_logo.svg');
    background-repeat: no-repeat;
    background-position-x: right;
    background-position-y: 40px;
    opacity: 0.5
`;

export const Title = styled.div`
    line-height: 40px;
    margin-top: 56px;
    margin-bottom: 20px;
    display: flex;
    align-items: center;
    color: rgba(255, 255, 255, 0.8);

    @media ${smallMediaQuery} {
        font-size: 22px;
    }
`;

export const SubTitle = styled.div`
    font-weight: normal;
    font-size: 24px;
    line-height: 32px;
    display: flex;
    align-items: center;
    color: rgba(255, 255, 255, 0.8);
    margin-bottom:12px;

    @media ${smallMediaQuery} {
        font-size: 17px;
    }
`
export const FormBody = styled.div`
    margin-left: 31px;

    @media ${smallMediaQuery} {
        font-size: 16px;
        margin-left: 20px;
    }
`;

export const FormSubmitButton = styled.button.attrs({ type: 'submit' })`
    display: block; 
    background: #F8971D;
    border-radius: 4px;
    font-size: 14px;
    line-height: 24px;
    align-items: center;
    letter-spacing: 0.09em;
    text-transform: uppercase;
    margin-bottom: 28px;
    color: #FFFFFF;
    height: 36px;
    width: 98px;
`;

export const FormLabel = styled.label`
    font-weight: normal;
    font-size: 18px;
    line-height: 24px;
    color: rgba(255, 255, 255, 0.9);
    margin-bottom: 18px;

    @media ${smallMediaQuery} {
        margin-left: 0;
    }
`;

export const FormLabelText = styled.span`
    margin-left:9px;
    font-weight: normal;
    font-size: 18px;
    line-height: 24px;
    color: rgba(255, 255, 255, 0.9);
`;

export const OtherTextbox = styled.textarea`
    height: 132px;
    margin-left:30px;
    margin-bottom: 18px;
    border: 1px solid rgba(255, 255, 255, 0.8);
    box-sizing: border-box;
    border-radius: 4px;
    background: transparent;
    width: 295px;

    @media ${smallMediaQuery} {
        margin-left: 0;
    }
`;

export const EmailTextBox = styled.input.attrs({type: 'text'})`
    width: 355px;
    height: 40px;
    border: 1px solid rgba(255, 255, 255, 0.8);
    box-sizing: border-box;
    border-radius: 4px;
    background-color: transparent;
    margin-bottom: 18px;
    padding-left: 4px;
    &::placeholder {
        padding-left: 4px;
        color: rgba(255, 255, 255, 0.3);
    }

    @media ${smallMediaQuery} {
        width: 330px;
    }
`;

export const Link = styled.a`
    font-weight: normal;
    font-size: 16px;
    line-height: 20px;
    display: flex;
    align-items: center;
    text-decoration: none;
    margin-top: 10px;
    color: rgba(255, 255, 255, 0.9);
    img {
        margin-right: 10px;
    }
    &:hover {
        text-decoration: underline;
        decoration-skip-ink: objects;
    }
`;

export const TopLabel = styled.div`
    margin-bottom: 18px;
    font-weight: normal;
    font-size: 18px;
    line-height: 24px;
    color: rgba(255, 255, 255, 0.9);
`;

export const OtherBox = styled.div`
    margin-left: 29px;
    
    @media ${smallMediaQuery} {
        margin-left: 0;
    }
`;